export const header = {
    accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer datura_$ilt1G70ZdarxwEdKRYZC9Ibct0OWFgoaloDjgTl0fM4`,
}
